<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <VueTabs
      class="vue-tabs-type-1"
      v-model="currentCountry"
      @tab-change="handleTabChange"
    >
      <VTab
        v-for="country of countriesList"
        :title="country.countries__name"
        :key="country.countries__id"
        :data="country"
      >
      </VTab>
    </VueTabs>

    <div class="tw-px-[26px] tw-py-[15px]">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-gap-[10px]">
          <button class="tw-app-btn-primary-outline" @click="loadData(1)">
            {{ dataLang["register_btn_filter_on"] }}
          </button>
          <button class="tw-app-btn-primary-outline" @click="resetFilter">
            {{ dataLang["register_btn_filter_off"] }}
          </button>
        </div>
        <!-- <BasePagination
            :page-count="numPages"
            :pagination-params="paginationFinesStateParams"
            :showLimitInput="false"
            :page-range="10"
            :margin-pages="0"
            :break-view-class="''"
            :click-handler="loadData"
            :prev-text="''"
            :next-text="''"
            :container-class="'custom-pagination'"
            :page-class="'custom-pagination__item'"
            :pageLinkClass="'custom-pagination__item-link'"
          >
          </BasePagination> -->
      </div>
      <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
        <BaseLoader v-if="localLoading" style="z-index: 50"></BaseLoader>
        <ve-table
          class="fixed-header rest-style-table"
          style="width: 100%; z-index: 1"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="menu__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          :cell-style-option="cellStyleOption"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }"
          :clickHighlight="false"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="addNote"
      width="500"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="onOpenMainModal"
      @beforeClose=""
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('addNote')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            Раздел {{ dataForModal?.menu__number }}
            <span class="tw-text-[#0056AF]">•</span>
            {{ dataForModal?.translations__translation }}
          </div>

          <div class="tw-mb-[15px]" ref="academy__video_link">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["register_videolinks_text_6"] }}
            </div>
            <BaseInputNew
              placeholder=""
              input-name="academy_video__link"
              @input="updateValue"
              :value="dataForModal.academy_video__link"
              :horizontalTitle="false"
              inputClass="tw-app-input-type-3"
            >
            </BaseInputNew>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="
                () => {
                  $modal.hide('addNote');
                }
              "
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="onSendData"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["register_academy_text_12"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import EventBus from "@/event-bus";

import VueRutube from "vue-rutube";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    VueRutube,
  },

  data() {
    return {
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      activePagePagination: {},
      dataForModal: {
        academy__video_link: "https://",
      },
      selectsData: {},
      currentCountry: "",
      currentCountryID: "",
      countriesList: [],
      fileUrl: "",
      fileId: "",
      selectsFilter: { subject: [] },
      isTypeCreateModal: true,
      isOpenModal: false,
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.dataForModal = row;
              this.$modal.show("addNote");
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
    };
  },
  methods: {
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    play() {
      this.player.play();
    },
    pause() {
      this.player.pause();
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    onOpenMainModal() {
      this.isOpenModal = true;
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    handleTabChange(tabIndex, newTab, oldTab) {},

    onSendData() {
      if (Object.keys(this.updatedValues).length) {
        GeneralService.edit(
          `/super/videolinks/${this.dataForModal?.menu__id}`,
          {
            countryId: this.currentCountryID,
            academy_video__link: this.updatedValues.academy_video__link,
          }
        )
          .then((data) => {
            this.$toast.success(data.data.message);
            this.$modal.hide("addNote");
            this.updatedValues = {};
            this.dataForModal = {};
            this.loadData();
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message ?? e, { duration: 5000 });
          });
      } else {
        this.$modal.hide("addNote");
      }
    },

    deleteRow() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(`/super/academy/${this.activeSelectRowsMultiple}`)
          .then((data) => {
            this.$toast.success(data.data.message);
            this.loadData();
          })
          .catch((e) => {
            if (e.response.data.message) {
              this.$toast.error(e.response.data.message, { duration: 5000 });
            }
          });
      }
    },

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.loadData();
    },

    loadData() {
      this.localLoading = true;
      Promise.all([
        GeneralService.get("/whoami")
          .then((who) => {
            this.currentCountryID = who.data.data.company_default_country_id;
          })
          .catch((e) => {
            console.log(e);
          }),
        GeneralService.get(`/countries`)
          .then((data) => {
            this.countriesList = data.data.data.rows;
          })
          .catch((e) => {
            console.error(e);
          }),
      ]).then(() => {
        GeneralService.get(
          `/super/videolinks/table/main/${this.currentCountryID}`,
          {
            params: {
              // ...this.paginationFinesStateParams,e
              limit: 10000,
              where: JSON.stringify([...this.filter]),
            },
          }
        )
          .then((data) => {
            this.dataTable = data.data.data;
            this.getFinesAll(data.data.data);
            this.currentCountry = this.countriesList.find(
              (x) => x.countries__id == this.currentCountryID
            ).countries__name;
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      console.log(data);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        let indexed = this.filter.findIndex((x) => x.field == data.name);
        this.filter[indexed].value = newValueFilter;
        if (data?.operator) {
          this.filter[indexed].operator = data.operator;
        }
      }
      let indexed = this.filter.findIndex((x) => x.field == data.name);
      if (indexed !== -1) {
        this.filter[indexed].value = newValueFilter;
        if (data.type == "delete") {
          console.log(323323223);
          this.filter.splice(indexed, 1);
        }
      }
    },
    onOpenModalReview() {},

    async onLoadFile(e) {
      this.localLoading = true;
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", "default");
      try {
        let dataFrom = await GeneralService.editOrCreate("/storage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.fileUrl = dataFrom.data.data.url;
        this.fileId = dataFrom.data.data.id;
        this.dataForModal.academy__file_id = dataFrom.data.data.id;

        this.updateValue({
          name: "academy__file_id",
          value: dataFrom.data.data.id,
        });
        this.localLoading = false;
      } catch (error) {
        this.$toast.error(error, { duration: 5000 });
        this.$modal.hide("addNote");
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    EventBus.$on("updateContentData", () => {
      this.loadData();
    });
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),
    player() {
      return this.$refs.player;
    },
    columns() {
      return [
        {
          field: "menu__number",
          key: "1623236",
          title: this.dataLang["register_videolinks_text_1"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  onKeyupEnter={this.loadData}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"menu__number"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "translations__translation",
          key: "162336",
          title: this.dataLang["register_videolinks_text_2"],
          align: "left",
          width: "25%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  onKeyupEnter={this.loadData}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"translations__translation"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "academy_video__link",
          key: "12861326",
          title: this.dataLang["register_videolinks_text_3"],
          align: "center",
          width: "45%",

          ellipsis: {
            showTitle: false,
            lineClamp: false,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                style={"-webkit-line-clamp: none !important; display: block;"}
              >
                {row.academy_video__link ? (
                  <div
                    style={"text-decoration: underline; cursor: pointer;"}
                    onClick={() => {
                      this.$modal.show("modalVideoSupport", {
                        videoID: row.academy_video__link,
                      });
                    }}
                  >
                    Смотреть
                  </div>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          field: "academy_video__updated_at",
          key: "16336",
          title: this.dataLang["register_videolinks_text_4"],
          align: "center",
          width: "20%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.academy_video__updated_at
                  ? this.$time(row.academy_video__updated_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
      ];
    },
  },
};
</script>
